import type { FaireProductEntity } from "../../entity_types/product";

export const p_99fbrve9qv: FaireProductEntity = {
  token: "p_99fbrve9qv",
  type: "product",
  name: "Hot Flash Tincture",
  brandToken: "b_bb3t3nl0h3",
  brandName: "Wilderness Maven Apothecary",
  imageUrl:
    "https://cdn.faire.com/fastly/67f687f985e6c5d4e3d7feb0ee4f0f726413a4dc4ab727598292a406169558f7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f08b45a2d39549d490eaf97babeb6042f08cc6ee29ee97a4078f1c1d0d4635cd.jpeg",
  ],
  priceDollars: 16.5,
  description:
    "This blend of botanicals is formulated to reduce the frequency and intensity of hot flashes and night sweats, and help the body find a more balanced response to hormonal shifts that can lead to improved sleep and more energy.\n\nMotherwort has weak estrogen-like actions, can help with mood swings, and is a relaxant.\n\nVitex (Chaste Berry) may help to rebalance and regulate hormones within the body, and may help reduce vaginal dryness.\n\nSage is grounding, cooling, and calming.\n\nWhite Peony Root supports the adrenals to help balance the stress response, and may help reduce sweating and hot sensations in the body.\n\nIngredients: Vitex*, Rose Buds*, Lemon Balm*, Black Cohosh*, Linden*, Wild Yam*, Motherwort*, Peppermint*, White Peony Root*, Dong Quai*, Licorice Root*, Sage*, Hibiscus*, Cane Spirits*, Vodka*, Vegetable Glycerin*, Distilled Water\n\n*Organic",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:18.674Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
